// 覚醒王の大きく動く技の間は、 画面の寄せ (src/cam_zoom.ts) を等倍まで引く (2026-10-27)。
//   作者 (広い舞台の検収メモ)「横や縦を広く使う技のときはカメラを引かないと見えないものが多い」「大技中はカメラを最大まで引いていいと思う」。
//   対象 = 大暴れ (幕2 rampage・幕3 rampageV5 = 壁と柱を跳ね回る) だけ (2026-10-29)。
//   突進と壁走りは外した。 作者「赤攻撃の突進とかで毎回極限までカメラを引いたりするのが違和感」「最大まで引くのは3幕の最初の大技だけ」。
//   突進・壁走りは、 二人の間合いで決まる普段の寄せ (cam_zoom の fit) に任せる。
//   構え (telegraph) から隙 (recovery) の終わりまで。 引く速さは予告と同じ速い方 (cam_zoom の ZOOM_OUT_RATE)。
//   等倍まで引いた後、 src/render.ts の applyFarView が世界を縮めて部屋全体 (柱から柱まで) を真ん中で映す (10-27 作者「大技の時はカメラを中央で固定して、全体が映るように」)。
import type { Boss } from './types'

const PULL_ATTACKS: ReadonlySet<string> = new Set(['rampage', 'rampageV5'])

export function awokenCamPullBack(boss: Pick<Boss, 'id' | 'state' | 'currentAttack'> | null | undefined): boolean {
  if (!boss || boss.id !== 'crowned-king-awoken' || !boss.currentAttack) return false
  if (boss.state !== 'telegraph' && boss.state !== 'active' && boss.state !== 'recovery') return false
  return PULL_ATTACKS.has(boss.currentAttack.id)
}
